<template>
    <div>
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ $lang('pagePassword.title') }}</span>
            <div class="popup__description">
                <span class="add__lock-text">{{ $lang('pagePassword.text') }}</span>
            </div>
        </div>
        <div class="popup__content">
            <form class="form" @submit.prevent="updateAccess">
                <div class="form__item">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('pagePassword.password') }}</span>
                        <el-input class="input input--big" type="password" placeholder="******" v-model="passwordInfo.password" required show-password></el-input>
                    </label>
                </div>
                <div class="form__item">
                    <button class="btn btn--middle btn--main-bg">{{ $lang('pagePassword.save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: "pagePassword",
        props: ['page_id'],
        data: () => ({
            windowWidth: window.innerWidth,
            password: '',
        }),
        computed: {
            ...mapState('cabinet',[
                'passwordInfo',
            ]),
        },
        methods: {
            ...mapActions('cabinet',[
                'setPassword',
            ]),
            updateAccess() {
                this.passwordInfo.id = this.page_id;

                this.setPassword();
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        }
    }
</script>

<style>
    .popup__description {
        margin-top: 15px;
    }
</style>
